(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bw-quiz"]) return;
  try {
    
(()=>{
const init=()=>{const dialog=document.getElementById('BlancaFinder');if(!dialog||dialog.dataset.ready)return;dialog.dataset.ready='true';let data=[];try{data=JSON.parse(document.getElementById('BlancaFinderProducts').textContent).filter(p=>p.url)}catch(e){}let step=0,goal='',opener;
const label=dialog.querySelector('[data-bw-step-label]'),back=dialog.querySelector('[data-bw-back]'),restart=dialog.querySelector('[data-bw-restart]');
const show=n=>{step=n;dialog.querySelectorAll('[data-bw-step]').forEach(el=>el.hidden=Number(el.dataset.bwStep)!==n);back.hidden=n===0;restart.hidden=n!==2;label.textContent=(n+1)+' / 3';dialog.querySelector('.bw-quiz-progress span').style.width=((n+1)/3*100)+'%';const h=dialog.querySelector('[data-bw-step="'+n+'"] h3');h.tabIndex=-1;h.focus()};
document.addEventListener('click',e=>{const trigger=e.target.closest('[data-bw-quiz]');if(!trigger)return;opener=trigger;document.querySelectorAll('.bw-mobile-menu[open]').forEach(m=>m.open=false);dialog.showModal();document.body.classList.add('bw-dialog-open');show(0)});
dialog.querySelector('[data-bw-close]').onclick=()=>dialog.close();dialog.addEventListener('close',()=>{document.body.classList.remove('bw-dialog-open');opener?.focus()});
dialog.querySelectorAll('[data-bw-goal]').forEach(button=>button.onclick=()=>{goal=button.dataset.bwGoal;const target=dialog.querySelector('[data-bw-options]');target.replaceChildren();data.filter(p=>p.goal===goal).forEach(p=>{const b=document.createElement('button');b.textContent=p.label;b.onclick=()=>{const result=dialog.querySelector('[data-bw-result]');result.replaceChildren();if(p.image){const im=document.createElement('img');im.src=p.image;im.alt=p.title;im.width=400;im.height=400;result.append(im)}const h=document.createElement('h4');h.textContent=p.title;const reason=document.createElement('p');reason.textContent=p.reason;const price=document.createElement('p');price.textContent=p.price;const a=document.createElement('a');a.href=p.url;a.className='bw-button';a.textContent=p.available?(window.blancaStrings?.view||'View product'):(window.blancaStrings?.soldOut||'Sold out — view details');result.append(h,reason,price,a);show(2)};target.append(b)});show(1)});back.onclick=()=>show(Math.max(0,step-1));restart.onclick=()=>show(0);
};init();document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
